"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner8"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// import mockClient from '../_mockApolloClient.js';

var AttendanceTable = function AttendanceTable(props) {
  var multipleGroupsSelected = true;
  var colors = props.colors;
  var _renderSessionCols = function _renderSessionCols(fill, fillVal) {
    // fill = array of cell indexes to fill
    // fillVal = value to fill in these cells
    var sessionCols = [];
    for (var i = 1; i <= props.totalSessions; i++) {
      var cellVal = void 0;
      if (fill) {
        if (fill.includes(i)) {
          cellVal = fillVal;
        }
      } else {
        cellVal = i;
      }
      sessionCols.push( /*#__PURE__*/_react["default"].createElement("td", {
        key: i
      }, cellVal));
    }
    return sessionCols;
  };
  var _renderTableBody = function _renderTableBody(data) {
    if (data.length < 1) {
      return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: props.totalSessions * 2 + 4
      }, "No data has been entered for the selected groups."));
    }
    return data.map(function (group) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: group.groupName
      }, multipleGroupsSelected && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
        rowSpan: group.participants.length + 1
      }, group.groupName)), group.participants.map(function (participant) {
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: participant.id
        }, /*#__PURE__*/_react["default"].createElement("td", null, participant.name), _renderSessionCols(participant.attended, /*#__PURE__*/_react["default"].createElement("span", {
          style: colors ? {
            color: colors.primary
          } : {}
        }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null))), /*#__PURE__*/_react["default"].createElement("td", {
          className: _style["default"].tableHeadingAlt
        }, Math.round(participant.youthAttendanceRate * 100), "%"), _renderSessionCols(participant.caregiverAttended, /*#__PURE__*/_react["default"].createElement("span", {
          style: colors ? {
            color: colors.primary
          } : {}
        }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null))), /*#__PURE__*/_react["default"].createElement("td", {
          className: _style["default"].tableHeadingAlt
        }, Math.round(participant.caregiverAttendanceRate * 100), "%"));
      }));
    });
  };
  var renderTable = function renderTable(tableProps) {
    if (tableProps.data.length > 0 && !tableProps.loading) {
      // console.log(tableProps.data);
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.BrowserOnly, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group",
        style: {
          marginBottom: '0.7em'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-sm btn-default dropdown-toggle ".concat(_style["default"].multipurposeButton, " ").concat(tableProps.loading ? _style["default"].rotating : ''),
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }, tableProps.loading ? /*#__PURE__*/_react["default"].createElement(_spinner["default"], null) : /*#__PURE__*/_react["default"].createElement(_menu["default"], null)), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "dropdown-menu"
      }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        onClick: tableProps.loadData
      }, "Reload data")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        onClick: tableProps.downloadCsv
      }, "Download CSV"))))), /*#__PURE__*/_react["default"].createElement("table", {
        className: _style["default"].table
      }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, multipleGroupsSelected && /*#__PURE__*/_react["default"].createElement("th", {
        className: _style["default"].tableHeading,
        rowSpan: "2",
        style: colors ? {
          backgroundColor: colors.primary
        } : {}
      }, "Group ID"), /*#__PURE__*/_react["default"].createElement("th", {
        className: _style["default"].tableHeading,
        rowSpan: "2",
        style: colors ? {
          backgroundColor: colors.primary
        } : {}
      }, "Participant ID"), /*#__PURE__*/_react["default"].createElement("th", {
        colSpan: props.totalSessions,
        className: _style["default"].tableHeadingAlt
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Session Number")), /*#__PURE__*/_react["default"].createElement("th", {
        rowSpan: "2",
        className: _style["default"].tableHeading,
        style: colors ? {
          backgroundColor: colors.primary
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Youth Attendance Rate")), /*#__PURE__*/_react["default"].createElement("th", {
        colSpan: props.totalSessions,
        className: _style["default"].tableHeadingAlt
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Session Number")), /*#__PURE__*/_react["default"].createElement("th", {
        rowSpan: "2",
        className: _style["default"].tableHeading,
        style: colors ? {
          backgroundColor: colors.primary
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Caregiver Attendance Rate"))), /*#__PURE__*/_react["default"].createElement("tr", null, _renderSessionCols(), _renderSessionCols())), /*#__PURE__*/_react["default"].createElement("tbody", null, _renderTableBody(props.convertDataStructure(tableProps.data)))));
    }
    return null;
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"]
  // apolloClient={props.isPreview ? mockClient : undefined}
  , {
    graphqlVariables: {
      groupIds: props.filters.groupIds
    },
    query: props.query,
    columns: [{
      name: 'group.label',
      label: 'Group Name'
    }, {
      name: 'childRoles.metricspawn.assignmentProgressSummary.caregiverAttendanceAvg',
      label: 'Caregiver Attendance Average'
    }, {
      name: 'childRoles.metricspawn.assignmentProgressSummary.youthAttendanceAvg',
      label: 'Teen Attendance Average'
    }],
    render: renderTable
  });
};
AttendanceTable.propTypes = {
  query: _propTypes["default"].object,
  convertDataStructure: _propTypes["default"].func,
  colors: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  totalSessions: _propTypes["default"].number,
  filters: _propTypes["default"].object
};
AttendanceTable.defaultProps = {
  convertDataStructure: function convertDataStructure(data) {
    var getSessionsAttended = function getSessionsAttended(sessionData, node) {
      var sessions = [];
      sessionData.forEach(function (session) {
        if (session.devTags[node] === '1') {
          sessions.push(Number(session.deployment.label[session.deployment.label.length - 1]));
        }
      });
      return sessions;
    };
    var convertedData = [];
    if (data.length > 0) {
      convertedData = data.map(function (group) {
        if (group['group.groupId'] && group['childRoles.participantList'].length > 0) {
          return {
            groupId: group['group.groupId'],
            groupName: group['group.label'],
            sessionsCompleted: 5,
            participants: group['childRoles.participantList'].map(function (participant) {
              return {
                id: participant.pawn.pawnId,
                name: participant.fields.participantId,
                attended: getSessionsAttended(participant.assignmentProgressList, 'YouthSessionAttendance'),
                caregiverAttended: getSessionsAttended(participant.assignmentProgressList, 'CaregiverSessionAttendance'),
                youthAttendanceRate: participant.assignmentProgressSummary.youthAttAvg,
                caregiverAttendanceRate: participant.assignmentProgressSummary.caregiverAttAvg
              };
            })
          };
        }
        return null;
      });
    } else {
      convertedData = [{
        groupId: 0,
        groupName: 'Group1',
        sessionsCompleted: 5,
        participants: [{
          id: 1,
          name: 'MB0101',
          attended: [1, 2, 3, 4, 5],
          caregiverAttended: [1, 2, 3, 4, 5],
          youthAttendanceRate: 1,
          caregiverAttendanceRate: 1
        }, {
          id: 2,
          name: 'MB0102',
          attended: [1, 2, 3, 4, 5],
          caregiverAttended: [1, 2, 3, 4],
          youthAttendanceRate: 1,
          caregiverAttendanceRate: 0.8
        }, {
          id: 3,
          name: 'MB0103',
          attended: [1, 2, 4, 5],
          caregiverAttended: [1, 2, 4, 5],
          youthAttendanceRate: 1,
          caregiverAttendanceRate: 1
        }]
      }, {
        groupId: 1,
        groupName: 'Group2',
        sessionsCompleted: 5,
        participants: [{
          id: 4,
          name: 'MB0104',
          attended: [1, 2, 3, 4, 5],
          caregiverAttended: [1, 2, 3, 4, 5],
          youthAttendanceRate: 1,
          caregiverAttendanceRate: 1
        }, {
          id: 5,
          name: 'MB0105',
          attended: [1, 2, 3, 4, 5],
          caregiverAttended: [1, 2, 3, 4],
          youthAttendanceRate: 1,
          caregiverAttendanceRate: 0.8
        }, {
          id: 6,
          name: 'MB0106',
          attended: [1, 2, 4, 5],
          caregiverAttended: [1, 2, 4, 5],
          youthAttendanceRate: 1,
          caregiverAttendanceRate: 1
        }]
      }];
    }
    // console.log({ convertedData });
    var filteredData = convertedData.filter(function (d) {
      return d !== null;
    }).filter(function (i) {
      return i.participants.length > 0;
    });

    // console.log('from base-packages', filteredData);
    return filteredData;
  }
};
var _default = exports["default"] = AttendanceTable;